import { addValidator } from '@nelio/forms/validation';

addValidator( 'select' );
